
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";

import { hideModal } from "@/core/helpers/dom";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "epay-sale-modal",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const route = useRoute();
    const createEPaySaleModalRef = ref<HTMLElement | null>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);

    const validation = Yup.object().shape({
      accountholder: Yup.string().required().label("Account Holder"),
      description: Yup.string().required().label("Description"),
      amount: Yup.string().required().label("Amount"),
      invoice: Yup.string().required().label("Invoice"),
      exp_month: Yup.string().required().label("Expiration Month"),
      exp_year: Yup.string().required().label("Expiration Year"),
      card_number: Yup.string().required().label("Card Number"),
      avsstreet: Yup.string().required().label("Avs Street"),
      avszip: Yup.string().required().label("Avs Zip"),
      cardcode: Yup.string().required().label("Card Code"),
    });

    const handleSubmit = async (values) => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      const exp_month = ("0" + values.exp_month.toString()).slice(-2);
      const exp_year = (
        values.exp_year +
        (new Date().getFullYear() - 1) -
        2000
      ).toString();

      try {
        // eslint-disable-next-line
        const payload: any = {
          AccountHolder: values.accountholder,
          Details: {
            Description: values.description,
            Amount: values.amount,
            Invoice: values.invoice,
          },
          CreditCardData: {
            CardNumber: values.card_number,
            CardExpiration: exp_month + exp_year,
            AvsStreet: values.avsstreet,
            AvsZip: values.avszip,
            CardCode: values.cardcode,
          },
        };
        const res = await ApiService.post(
          `transactions/${route.params.id}/4?action=runSale`,
          payload
        );

        if (res.data.success) {
          Swal.fire({
            text: "USAEPay Sale Successfully Run!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            hideModal(createEPaySaleModalRef.value);
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      handleSubmit,
      createEPaySaleModalRef,
      submitButton,
      validation,
    };
  },
});
